// extracted by mini-css-extract-plugin
module.exports = {"unSelected":"src-pages-business-components-BusinessProtocol-__index__unSelected--3Stma","protocolBtn":"src-pages-business-components-BusinessProtocol-__index__protocolBtn--3Sw1u"};